// src/AppLayout.jsx
import Navbar from "./components/NavBar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import MarketplaceSidebar from "./components/MarketplaceSidebar/MarketPlaceSidebar";
import Watermark from "./components/Watermark/Watermark";

const AppLayout = ({ children }) => {
  return (
    <div className="app">
      <Navbar />
      <Sidebar />
      <MarketplaceSidebar />
      <Watermark text="HR Labs" />
      <main className="main-content">{children}</main>
    </div>
  );
};

export default AppLayout;
